
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import TitleShareButton from '@/components/details/TitleShareButton.vue';
import TitleDetailLink from '@/components/nav/links/TitleDetailLink.vue';

// BUYBOX_EXP_4
import { BuyboxExp4Name, BuyboxExp4Variants } from '@/components/experiments/buybox-exp-4';
import { buyboxExp4Validation } from '@/components/experiments/buybox-exp-4/utils';
// BUYBOX_EXP_4

// BUYBOX_EXP_5
import { BuyboxExp5Name, BuyboxExp5Variants } from '@/components/experiments/buybox-exp-5';
import { buyboxExp5Validation } from '@/components/experiments/buybox-exp-5/utils';
import { namespace } from 'vuex-class';
const Experiment = namespace('experiment');
const User = namespace('user');
// BUYBOX_EXP_5

import { ShareMethod } from '@/enums/share-methods';
import { ShareHelper } from '@/helpers/share-helper';
import { ObjectType } from '@/@types/graphql-types';

@Component({
	name: 'TitleBlock',
	components: {
		TitleShareButton,
		TitleDetailLink,
	},
})
export default class TitleBlock extends Vue {
	@Prop({ required: true }) titleId: number;
	@Prop({ required: true }) titleObjectType: ObjectType;
	@Prop({ default: '' }) titleName: string;
	@Prop({ default: '' }) originalTitleName: string;
	@Prop({ default: '' }) seasonName: string;
	@Prop({ default: '' }) titleFullPath: string;
	@Prop({ default: null }) originalReleaseYear: number;
	@Prop({ default: true }) showShare: boolean;
	@Prop({ default: '' }) metaH1Text: string;
	@Prop({ default: '' }) metaH2Text: string;
	@Prop() title: any;

	// BUYBOX_EXP_4
	// BUYBOX_EXP_5
	@Prop({ default: false }) isTitleUpcoming: boolean;
	@Prop() titleOffers: any;
	@Prop() onlyHasCinemaOffers: boolean | undefined;
	@Experiment.Getter activeVariantsWithControlGroup: Record<string, string>;
	@User.Getter isLoggedIn: () => boolean;
	// BUYBOX_EXP_4
	// BUYBOX_EXP_5

	share(method?: ShareMethod) {
		ShareHelper.share(
			{
				titleId: this.titleId,
				titleObjectType: this.titleObjectType,
				titleFullPath: this.titleFullPath,
				titleName: this.titleName,
			},
			method
		);
	}

	// BUYBOX_EXP_4
	get isBuyboxExp4() {
		const variant = this.activeVariantsWithControlGroup[BuyboxExp4Name];
		// @ts-ignore disable control & v1
		return !!variant && variant === BuyboxExp4Variants.VARIANT_2;
	}

	get buyboxExp4Variant() {
		return this.activeVariantsWithControlGroup[BuyboxExp4Name];
	}

	get buyboxExp4ValidationPassed() {
		return buyboxExp4Validation(
			this.titleObjectType,
			this.isLoggedIn(),
			this.isTitleUpcoming,
			this.titleOffers,
			this.onlyHasCinemaOffers,
			this.isBuyboxExp4
		);
	}

	get releaseYearAdjustment4() {
		return (
			this.isMounted && this.buyboxExp4ValidationPassed && this.buyboxExp4Variant === BuyboxExp4Variants.VARIANT_2
		);
	}
	// BUYBOX_EXP_4

	// BUYBOX_EXP_5
	isMounted = false;

	mounted() {
		this.isMounted = true;
	}

	get isBuyboxExp5() {
		return !!this.activeVariantsWithControlGroup[BuyboxExp5Name];
	}

	get buyboxExp5Variant() {
		return this.activeVariantsWithControlGroup[BuyboxExp5Name];
	}

	get buyboxExp5ValidationPassed() {
		return buyboxExp5Validation(
			this.titleObjectType,
			this.isLoggedIn(),
			this.isTitleUpcoming,
			this.titleOffers,
			this.onlyHasCinemaOffers,
			this.isBuyboxExp5
		);
	}

	get releaseYearAdjustment5() {
		return (
			this.isMounted &&
			this.buyboxExp5ValidationPassed &&
			(this.buyboxExp5Variant === BuyboxExp5Variants.VARIANT_1 ||
				this.buyboxExp5Variant === BuyboxExp5Variants.VARIANT_2)
		);
	}
	// BUYBOX_EXP_5
}
